import React, { useState, useEffect, useRef } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import style from "../../css/dashboard/Dashboard.module.css";
import ProfileEditModal from './ProfileEditModal';
import DashboardLanding from './admin_landing_dash/DashboardLanding';
import { API_BASE_URL } from '../ApiConfig';
import ThemeToggle from '../Theme_toggle';

import Scaner_upload from './Scaner/Scaner_upload';
import Total_users from './Total_users';
import User_contactus from './User_contactus';
import User_subscribe from './User_subscribe';
import WorkshopUpload from './workshop/Workshop_upload';
import Community_upload from './Community/Community_upload';
import StudymaterialUpload from './Study_material/Studymaterial_upload';
import SendNotification from './Send_notification';
import Transactionss from './Transactionss';
import axios from 'axios';
import { getSecureToken } from '../ApisService/apiService';

const Admin = () => {
  const location = useLocation();
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [fullName, setFullName] = useState('');
  const userEmail = localStorage.getItem('userEmail');
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1040);

  const navigate = useNavigate();
  useEffect(() => {
    const isAdmin = localStorage.getItem('islogin');
    if (!isAdmin || isAdmin !== 'true') {
      navigate('/admin');
    }
  }, []);

  useEffect(() => {
    const checkSession = async () => {
      const { secrettoken, ts } = await getSecureToken();
      try {
        const res = await axios.get(`${API_BASE_URL}adminauth/check_admin_session.php`, {
          withCredentials: true,
          headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts
          }
        });

        // console.log(res.data);

        if (res.data.status !== "ok") {
          const theme = localStorage.getItem("theme");
          localStorage.clear();
          if (theme) {
            localStorage.setItem("theme", theme);
          }
          navigate('/admin');
        }

      } catch (error) {
        console.error("Session check failed", error.response?.data || error.message);
        navigate('/admin');
      }
    };

    checkSession();
  }, []);



  const menuItems = [
    { name: 'Dashboard', path: '/admin_dash', icon: 'fa-solid fa-house' },
    { name: 'Workshop', path: '/admin_dash/Workshop_upload', icon: 'fa-solid fa-chalkboard' },
    { name: 'Scanners', path: '/admin_dash/scanners_upload', icon: 'fa-solid fa-magnifying-glass' },
    { name: 'Study Material', path: '/admin_dash/studymaterial_upload', icon: 'fa-solid fa-book' },
    { name: 'Community group', path: '/admin_dash/communitygroup_upload', icon: 'fa-solid fa-users' },
    { name: 'Total users', path: '/admin_dash/total_users', icon: 'fa-solid fa-magnifying-glass' },
    { name: 'User quries', path: '/admin_dash/user_contactus', icon: 'fa-solid fa-address-book' },
    { name: 'Subscribers', path: '/admin_dash/user_subscribe', icon: 'fa-solid fa-user-plus' },
    { name: 'Notification', path: '/admin_dash/Notification', icon: 'fa-solid fa-bell' },
    { name: 'TRANSACTIONS', path: '/admin_dash/transaction', icon: 'fa-solid fa-money-check-dollar' },
  ];

  useEffect(() => {
    const updateView = () => setIsMobileView(window.innerWidth <= 1040);
    window.addEventListener('resize', updateView);
    return () => window.removeEventListener('resize', updateView);
  }, []);

  useEffect(() => {
    const storedFullName = localStorage.getItem('fullName');
    if (storedFullName) setFullName(storedFullName);
  }, []);



  const handleLogout = async () => {
    const { secrettoken, ts } = await getSecureToken();

    try {
      const response = await axios.post(`${API_BASE_URL}logout.php`, {}, {
        headers: {
          'X-TOKEN': secrettoken,
          'X-TIMESTAMP': ts
        },
        withCredentials: true,
      });

      if (response.data.status === "success") {
        const theme = localStorage.getItem("theme");
        localStorage.clear();
        if (theme) {
          localStorage.setItem("theme", theme);
        }
        window.location.href = "/";
      }
    } catch (error) {
      console.log("Logout error:", error);
    }
  };

  const handleProfileClick = () => setProfileModalOpen(true);
  const closeProfileModal = () => setProfileModalOpen(false);

  const handleSectionChange = (path) => {
    navigate(path);
  };

  return (
    <>
      <div className={`${style.da} container-fluid`}>
        <div className={`${style.dashboard} row`}>
          {!isMobileView && (
            <div className={`${style.leftpannel} col-2`}>
              <div className={style.header__logo}>
                <h1 className={style.header__title}>
                  <span className={style.header__light}>SWING</span><span className={style.header__light}></span>ALGO
                </h1>
              </div>

              <div className={style.dashboardlink}>
                {menuItems.map((item) => (
                  <div
                    key={item.path}
                    className={`${style.dash} ${location.pathname === item.path ? style.active : ''}`}
                    onClick={() => navigate(item.path)}
                  >
                    <button className={style.dashlink}>
                      <i className={`${item.icon} ${style.dashicon}`}></i>
                      <span className={style.dashtxt}>{item.name}</span>
                    </button>
                  </div>
                ))}
              </div>

              <div className={style.logoutbtn}>
                <button className={style.logout} onClick={handleLogout}>
                  <i className={`${style.logouticon} fa-solid fa-right-from-bracket`}></i>
                  <span className={style.logoutword}>Logout</span>
                </button>
              </div>
            </div>
          )}

          {/* <div className={`${style.dashboardcenter} col`}>
            <div className={`${style.dashfluid} container-fluid`}>
              <div className={`${style.dashboardheader} row`}>
                <div className={`${style.dashboardwrite} col`}>
                  {menuItems.find((item) => item.path === location.pathname)?.name.toUpperCase() || 'DASHBOARD'}
                </div>
                <div className={`${style.dashright} col d-flex`}>
                  <div className="col text-end me-4 d-flex gap-5 justify-content-end">
                    <ThemeToggle />
                  </div>
                  <div className={`${style.profilename} col d-flex`} onClick={handleProfileClick}>
                    <div className={style.name}>{userEmail}</div>
                    <div className="col align-content-center">
                      <i className={`${style.profileimg} fa-solid fa-user`} />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

          <div className={`${style.dashboardcenter} ${isMobileView ? 'col' : 'col'}`}>
            <div className={`${style.dashfluid} container-fluid`}>
              <div className={`${style.dashboardheader} row`}>
                <div className={`${style.dashboardwrite} col`}>
                  {isMobileView && (
                    <div className={`col d-flex justify-content-between d-lg-none `}>


                      <h1 className={style.header__title} style={{ alignContent: 'center' }}>
                        <span className={style.header__light}>SWING</span><span className={style.header__light}></span>ALGO
                      </h1>

                      <ThemeToggle />
                    </div>
                  )}
                  {menuItems.find((item) => item.path === location.pathname)?.name.toUpperCase() || 'DASHBOARD'}
                </div>
                <div className={`${style.dashright} col d-flex`}>
                  <div className={`col text-end me-4 d-flex gap-5 justify-content-end`}>
                    <ThemeToggle />

                  </div>
                  <div className={`${style.profilename} col d-flex`} onClick={() => setProfileModalOpen(true)}>
                    <div className={style.name}>{userEmail}</div>
                    <div className="col align-content-center">
                      <i className={`${style.profileimg} fa-solid fa-user`} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Routes>
              <Route path="/" element={<DashboardLanding />} />
              <Route path="/Workshop_upload" element={<WorkshopUpload />} />
              <Route path="/scanners_upload" element={<Scaner_upload />} />
              <Route path="/studymaterial_upload" element={<StudymaterialUpload />} />
              <Route path="/communitygroup_upload" element={<Community_upload />} />
              <Route path="/total_users" element={<Total_users />} />
              <Route path="/user_contactus" element={<User_contactus />} />
              <Route path="/user_subscribe" element={<User_subscribe />} />
              <Route path="/Notification" element={<SendNotification />} />
              <Route path="/transaction" element={<Transactionss />} />
            </Routes>
          </div>
        </div>
      </div>

      <ProfileEditModal isOpen={isProfileModalOpen} onClose={closeProfileModal} />

      {isMobileView && (
        <div className={`${style.mobileNav} fixed-bottom d-flex justify-content-around`}>
          <button onClick={() => handleSectionChange('/admin_dash')} className={style.navButton}>
            <i className="fa-solid fa-house"></i>
            <span className={style.navText}>Dashboard</span>
          </button>
          <button onClick={() => handleSectionChange('/admin_dash/Workshop_upload')} className={style.navButton}>
            <i className="fa-solid fa-chalkboard"></i>
            <span className={style.navText}>Workshop</span>
          </button>
          <button onClick={() => handleSectionChange('/admin_dash/communitygroup_upload')} className={style.navButton}>
            <i className="fa-solid fa-users px-2"></i>
            <span className={style.navText}>Community</span>
          </button>
          <button onClick={() => handleSectionChange('/admin_dash/scanners_upload')} className={style.navButton}>
            <i className="fa-solid fa-magnifying-glass"></i>
            <span className={style.navText}>Scanners</span>
          </button>
          <button onClick={() => handleSectionChange('/admin_dash/studymaterial_upload')} className={style.navButton}>
            <i className="fa-solid fa-book"></i>
            <span className={style.navText}>Study</span>
          </button>
          <button onClick={() => handleSectionChange('/admin_dash/transaction')} className={style.navButton}>
            <i className="fa-solid fa-money-check-dollar"></i>
            <span className={style.navText}>transaction</span>
          </button>

          <div className={`dropup-center dropup ${style.dropup}`}>
            <button className={`btn btn-secondary dropdown-toggle ${style.dropupbtn}`} data-bs-toggle="dropdown">
              <i className="fa-solid fa-caret-up"></i>
            </button>
            <ul className={`dropdown-menu ${style.dropupmenu}`}>
              <li className="py-2">
                <button onClick={handleProfileClick} className={style.navButton}>
                  <i className="fa-solid fa-user px-2"></i>
                  <span className={style.dropText}>Profile</span>
                </button>
              </li>
              <li className="py-2">
                <button onClick={() => handleSectionChange('/admin_dash/total_users')} className={style.navButton}>
                  <i className="fa-solid fa-users px-2"></i>
                  <span className={style.dropText}>Total users</span>
                </button>
              </li>
              <li className="py-2">
                <button onClick={() => handleSectionChange('/admin_dash/user_contactus')} className={style.navButton}>
                  <i className="fa-solid fa-address-book px-2"></i>
                  <span className={style.dropText}>Contact us</span>
                </button>
              </li>
              <li className="py-2">
                <button onClick={() => handleSectionChange('/admin_dash/user_subscribe')} className={style.navButton}>
                  <i className="fa-solid fa-user-plus px-2"></i>
                  <span className={style.dropText}>Subscribers</span>
                </button>
              </li>
              <li className="py-2">
                <button onClick={() => handleSectionChange('/admin_dash/Notification')} className={style.navButton}>
                  <i className="fa-solid fa-bell px-2"></i>
                  <span className={style.dropText}>Notification</span>
                </button>
              </li>

              <li className="py-2">
                <button className={style.droplogout} onClick={handleLogout}>
                  <span className={style.logoutword}>Logout</span>
                  <i className={`fa-solid fa-right-from-bracket px-2 ${style.logouticon}`}></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Admin;
